import { Route } from "react-router";
import { LazySiteMapRoutes, siteMapPathPrefix } from "./index";
import React from "react";
import { ModalLoadingSpinner } from "../modal-loading-spinner";
import { EditorsAppLayoutShell } from "../../EditorsAppLayoutShell";
import { Global } from "@emotion/react";
import { getGlobalFontStyles } from "../../styles/styles-global";
import { AppView } from "../../styles/AppView";

export const SitemapRouterRoutes = [
  <Route
    key={"1"}
    path={siteMapPathPrefix + "/*"}
    element={
      <AppView>
        <EditorsAppLayoutShell headline={"Preview - Sitemap"}>
          <Global styles={getGlobalFontStyles("en")} />
          <React.Suspense fallback={<ModalLoadingSpinner />}>
            <LazySiteMapRoutes />
          </React.Suspense>
        </EditorsAppLayoutShell>
      </AppView>
    }
  />,
];
